"use strict";
'use client';
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.CookieProvider = exports.CookieContext = void 0;
var react_1 = __importStar(require("react"));
var _1 = require(".");
var utils_1 = require("../common/utils");
exports.CookieContext = (0, react_1.createContext)(null);
function CookieProvider(_a) {
    var children = _a.children, pollingOptions = _a.pollingOptions;
    var _b = (0, react_1.useState)({}), cookies = _b[0], setCookies = _b[1];
    (0, react_1.useEffect)(function () {
        var initialCookies = (0, _1.getCookies)();
        if (!initialCookies) {
            return;
        }
        setCookies(initialCookies);
    }, []);
    (0, _1.useCookiesPolling)(function (newCookies) {
        if (newCookies) {
            setCookies(newCookies);
        }
    }, pollingOptions);
    var value = (0, react_1.useMemo)(function () {
        return {
            cookies: cookies,
            set: function (key, data) {
                setCookies(function (prev) {
                    var _a;
                    return (__assign(__assign({}, prev), (_a = {}, _a[key] = encodeURIComponent((0, utils_1.stringify)(data)), _a)));
                });
            },
            get: function (key) {
                var cookieValue = cookies === null || cookies === void 0 ? void 0 : cookies[key];
                return cookieValue;
            },
            getAll: function () {
                return cookies;
            },
            has: function (key) {
                return cookies.hasOwnProperty(key);
            },
            delete: function (key) {
                if (!cookies.hasOwnProperty(key)) {
                    return;
                }
                setCookies(function (prev) {
                    var newCookies = __assign({}, prev);
                    delete newCookies[key];
                    return newCookies;
                });
            },
            revalidateCookiesState: function () {
                (0, _1.revalidateCookies)(function (newCookies) {
                    if (!newCookies) {
                        return;
                    }
                    setCookies(newCookies);
                }, cookies);
            },
        };
    }, [cookies]);
    return react_1.default.createElement(exports.CookieContext.Provider, { value: value }, children);
}
exports.CookieProvider = CookieProvider;
